var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications'),(_vm.user && _vm.$route.name !== 'game')?_c('navbar',{attrs:{"user":_vm.user},on:{"logout":_vm.logout}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }